export default __webpack_public_path__ + "static/media/iban2.dd685066.jpg";